import { ToggleButton, ToggleButtonGroup } from '@mui/material';

type Props = {
    loading: boolean;
    completedType: boolean | null;
    setCompletedType: (completedType: boolean | null) => void;
};

const SextforceMetricsCompletedSelector = (props: Props) => {
    const { loading, completedType, setCompletedType } = props;

    return (
        <ToggleButtonGroup
            value={completedType === null ? 'all' : completedType ? 'true' : 'false'}
            exclusive
            fullWidth
            color="secondary"
            size={'small'}
            disabled={loading}
            onChange={(e, value: string) => {
                if (!value) {
                    return;
                }

                setCompletedType(value === 'all' ? null : value === 'true');

                localStorage.setItem('sextforceMetricsOverviewCompletedType', value);
            }}
            sx={{ marginTop: '4px', height: '39px' }}
        >
            <ToggleButton color="secondary" value={'all'}>
                All
            </ToggleButton>
            <ToggleButton color="secondary" value={'false'} sx={{ minWidth: '120px' }}>
                Not Completed
            </ToggleButton>
            <ToggleButton color="secondary" value={'true'}>
                Completed
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

export default SextforceMetricsCompletedSelector;
